import React, { Component } from "react";
import PropTypes from "prop-types";
import ConfirmDeclineConfirmation from "./ConfirmDeclineConfirmation";
import Confirm from "./Confirm";
import Decline from "./Decline";
import { Wrapper } from "../styles/interview-styles";

class Interview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionConfirmationActive: true,
      actionConfirmation: null,
    };
  }

  handleActionConfirmation = (action) => {
    this.setState({
      actionConfirmation: action,
      actionConfirmationActive: false,
    });
  };

  handleCancel = (e) => {
    e.preventDefault();
    const { handleCancelRecruiterConfirmation } = this.props;
    this.setState({
      actionConfirmationActive: true,
      actionConfirmation: null,
    });
    handleCancelRecruiterConfirmation(e);
  };

  render() {
    const { actionConfirmationActive, actionConfirmation } = this.state;
    const {
      cardData,
      closeActionModalAfterSubmit,
      fetchKanbanData,
      handleCancelRecruiterConfirmation,
      interviewType,
    } = this.props;
    const { candidate } = cardData;

    return (
      <Wrapper>
        {actionConfirmationActive && (
          <ConfirmDeclineConfirmation
            handleActionConfirmation={this.handleActionConfirmation}
            handleCancelRecruiterConfirmation={
              handleCancelRecruiterConfirmation
            }
            interviewType={interviewType}
          />
        )}
        {actionConfirmation === "confirm" && (
          <Confirm
            candidate={candidate}
            handleCancel={this.handleCancel}
            closeActionModalAfterSubmit={closeActionModalAfterSubmit}
            fetchKanbanData={fetchKanbanData}
            cardData={cardData}
            interviewType={interviewType}
          />
        )}
        {actionConfirmation === "decline" && (
          <Decline
            candidate={candidate}
            handleCancel={this.handleCancel}
            closeActionModalAfterSubmit={closeActionModalAfterSubmit}
            fetchKanbanData={fetchKanbanData}
            cardData={cardData}
            interviewType={interviewType}
          />
        )}
      </Wrapper>
    );
  }
}

Interview.propTypes = {
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    updateStatusLink: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
  interviewType: PropTypes.string.isRequired,
};

export default Interview;
